export const createPackingList = item => {
  const widthOfRoll = item.piProduct?.product?.widthOfRoll || 0;
  const lengthOfRoll = item.piProduct?.product?.lengthOfRoll || 0;
  const rollPerPallet = item.rollPerPallet || 0;
  const packageQuantity = item.packageQuantity || 0;
  return `${rollPerPallet} ROLL x ${packageQuantity} PALLETS DIMENSION (WXLXH): ${widthOfRoll}” x ${lengthOfRoll}”`;
};

const isContainer = item => item?.piProduct?.product?.materialGroup === "PK00";

export const checkTotalQuantity = (listItem, item) => {
  const productChange = item?.piProduct?.id;
  const limitQuantity =
    (isContainer(item)
      ? item?.piProduct?.remainingQuantityEx
      : item?.piProduct?.remainingQuantityEx / item?.weightPerUnit) || 0;
  const allLineProduct = listItem.filter(
    item => item?.piProduct?.id === productChange
  );
  const allQuantity = allLineProduct.reduce(
    (sum, item) => sum + parseInt(item.quantity || 0, 10),
    0
  );
  return allQuantity > limitQuantity;
};
